import { Expert } from '../models';
import ApiResource from './ApiResource';

class ExpertResource extends ApiResource<Expert> {
  public endpoint = '/experts';
}

export const expertResource = new ExpertResource();
